import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {},
  horseAlertDialog: {
    "& .MuiDialogTitle-root": {
      padding: 20,
      "& .MuiTypography-root": {
        lineHeight: 1
      }
    },
    "& .MuiDialogContent-root": {
      padding: 0,
      borderTop: "none"
    },
    "& .MuiDialog-paper": {
      maxWidth: 296,
      margin: 0,
      [theme.breakpoints.up("sm")]: {
        marginLeft: `calc(${theme.widthTabletDrawer}px + env(safe-area-inset-left))`
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: `calc(${theme.widthDesktopDrawer}px + env(safe-area-inset-left))`
      }
    }
  },
  horseAlertDialogMessage: {
    padding: 20,
    paddingTop: 0,
    fontSize: 14,
    color: "#333333",
    lineHeight: "17px"
  },
  horseAlertDialogReasons: {
    padding: 20
  },
  horseAlertDialogReasonButton: {
    color: theme.palette.error.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${theme.palette.error.main}`,
    width: 116,
    height: 27,
    backgroundColor: "rgba(247, 61, 84, 0)",
    lineHeight: "17px",
    borderRadius: 0,
    fontSize: 13,
    textTransform: "none"
  },
  alertReason: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  alertReasonText: {
    fontSize: 14
  }
}));
